import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The admin panel is loaded only when /admin is opened, so it adds nothing to the public site.
const Admin = lazy(() => import('./Admin'));
const LandingPage = lazy(() => import('./LandingPage'));
const NotFound = lazy(() => import('./LandingPage').then((m) => ({ default: m.NotFound })));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="adm-boot">Loading admin...</div>}>
              <Admin />
            </Suspense>
          }
        />
        <Route path="/" element={<App />} />
        <Route
          path="/:slug"
          element={
            <Suspense fallback={null}>
              <LandingPage />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={null}>
              <NotFound />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
